import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class HistoryIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path d="M1.96 11.013l.54-.513v2l-2-.1.713-.677A7.656 7.656 0 0 1 0 7c0-4 3.9-7 7.4-7C11.2 0 15 2.4 15 7.8c0 5.9-5.4 6.9-6.5 7.1-.2 0-.5.1-.6.1l-.1-1a3.536 3.536 0 0 1 .6-.1c1.3-.2 5.6-1.2 5.6-6.1 0-5-3.6-6.8-6.6-6.8S1 3.6 1 7a7.152 7.152 0 0 0 .96 4.013z"/></svg>
        )
    }
}

export default withCssClassName(HistoryIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/history-icon.js